import request from '@/utils/request';
export function fetchPlatform() {
  return request({
    url: "/admin/platform/name",
    method: 'get'
  });
}
export function uploadImage(data) {
  return request({
    url: '/upload/image',
    method: 'post',
    data: data
  });
}